import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomTextField from '../../shared/CustomTextField';

const DealershipExternalProfileCard = ({ data }) => {
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <StyledTypography component="span">{data?.rnpName}</StyledTypography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container direction="column">
            <Grid item>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={6}>
                  <CustomPopupText text="External ID" required />
                  <CustomTextField name="firstName" defaultValue={data?.externalId} width="100%" disabled />
                </Grid>
                <Grid item xs={6}></Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={6}>
                  <CustomPopupText text="Created At" required />
                  <CustomTextField
                    id={data?.id}
                    name="createdAt"
                    defaultValue={data?.createdAt}
                    width="100%"
                    disabled
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomPopupText text="Updated At" required />
                  <CustomTextField name="updatedAt" defaultValue={data?.updatedAt} width="100%" disabled />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container direction="row">
                <Grid item xs={12}>
                  <CustomPopupText text="Additional Info" required />
                  <CustomTextField
                    name="title"
                    defaultValue={JSON.stringify(data?.additionalInfo)}
                    width="100%"
                    disabled
                    multiline
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<ArrowDropUpIcon sx={{ fontSize: '1.5rem' }} />} {...props} />
))(({ theme }) => ({
  height: '56px',
  padding: '16px',
  justifyContent: 'space-between',
  flexDirection: 'row-reverse',
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
    transform: 'rotate(180deg)',
  },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
  ...theme.applyStyles('dark', {
    backgroundColor: 'rgba(255, 255, 255, .05)',
  }),
}));

const StyledTypography = styled(Typography)(() => ({
  fontFamily: 'Montserrat',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '19.6px',
}));
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default DealershipExternalProfileCard;
